import React, { useState } from "react";
import { Button, Space, Tabs } from "antd";
import { BUGTable } from "./BUGTable";
import { BugOutlined, UserOutlined, TeamOutlined, CodeOutlined } from "@ant-design/icons";
import DeveloperView from "./DeveloperView";
const { TabPane } = Tabs;

const TicketTable = ({ list }) => {
  const [view, setView] = useState("ticket"); // 'ticket' | 'developer'

  return (
    <Tabs className="dashboardContainerTabs" defaultActiveKey="1" type="card" size="large" tabBarStyle={{ fontWeight: "bold", color: "#928c8c" }} style={{ marginTop: -20, paddingTop: -20 }}>
      <TabPane
        tab={
          <span>
            <BugOutlined /> Tickets
          </span>
        }
        key="1"
      >
        <BUGTable list={list} />
      </TabPane>
      {/* <TabPane
        tab={
          <span>
            <UserOutlined /> Developer
          </span>
        }
        key="2"
      >
        <DeveloperView />
      </TabPane> */}
    </Tabs>
  );
};

export default TicketTable;
